import { render, staticRenderFns } from "./DatatableDsbs.vue?vue&type=template&id=5afdeeec&"
import script from "./DatatableDsbs.vue?vue&type=script&lang=js&"
export * from "./DatatableDsbs.vue?vue&type=script&lang=js&"
import style0 from "./DatatableDsbs.vue?vue&type=style&index=0&id=5afdeeec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports